 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~96e27529","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f18c8dae","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~4f269f2f","3":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~ea494b20","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-en-uk-json","10":"source~i18n-widgets-es-json","11":"source~i18n-widgets-fi-json","15":"source~/esports-betting-rules-TR","16":"source~bet-builder-rules-AZ","17":"source~bet-builder-rules-DE","18":"source~bet-builder-rules-EN","19":"source~bet-builder-rules-ES","20":"source~bet-builder-rules-ES-MX","21":"source~bet-builder-rules-ET","22":"source~bet-builder-rules-FI","23":"source~bet-builder-rules-FR","24":"source~bet-builder-rules-HE","25":"source~bet-builder-rules-IT","26":"source~bet-builder-rules-JA","27":"source~bet-builder-rules-KA","28":"source~bet-builder-rules-LT","29":"source~bet-builder-rules-LV","30":"source~bet-builder-rules-PL","31":"source~bet-builder-rules-PT-BR","32":"source~bet-builder-rules-RO","33":"source~bet-builder-rules-RU","34":"source~bet-builder-rules-SQ","35":"source~bet-builder-rules-SV","36":"source~bet-builder-rules-TR","37":"source~bet-details-page","38":"source~betting-history-container","39":"source~betting-history-page","40":"source~betting-rules-AZ","41":"source~betting-rules-DA","42":"source~betting-rules-DE","43":"source~betting-rules-EN","44":"source~betting-rules-ES","45":"source~betting-rules-ES-MX","46":"source~betting-rules-FI","47":"source~betting-rules-FR","48":"source~betting-rules-HE","49":"source~betting-rules-IT","50":"source~betting-rules-JA","51":"source~betting-rules-PL","52":"source~betting-rules-PT","53":"source~betting-rules-PT-BR","54":"source~betting-rules-RO","55":"source~betting-rules-RU","56":"source~betting-rules-SQ","57":"source~betting-rules-SV","58":"source~betting-rules-TR","59":"source~bonus-info","60":"source~cashout-terms-AR","61":"source~cashout-terms-AZ","62":"source~cashout-terms-DA","63":"source~cashout-terms-DE","64":"source~cashout-terms-EN","65":"source~cashout-terms-ES","66":"source~cashout-terms-ES-MX","67":"source~cashout-terms-ET","68":"source~cashout-terms-FI","69":"source~cashout-terms-FR","70":"source~cashout-terms-HE","71":"source~cashout-terms-IT","72":"source~cashout-terms-JA","73":"source~cashout-terms-KA","74":"source~cashout-terms-KU","75":"source~cashout-terms-LT","76":"source~cashout-terms-LV","77":"source~cashout-terms-PL","78":"source~cashout-terms-PT","79":"source~cashout-terms-PT-BR","80":"source~cashout-terms-RO","81":"source~cashout-terms-RU","82":"source~cashout-terms-SQ","83":"source~cashout-terms-SR","84":"source~cashout-terms-SV","85":"source~cashout-terms-TR","86":"source~esports-betting-rules-AZ","87":"source~esports-betting-rules-DA","88":"source~esports-betting-rules-DE","89":"source~esports-betting-rules-EN","90":"source~esports-betting-rules-ES","91":"source~esports-betting-rules-ES-MX","92":"source~esports-betting-rules-ET","93":"source~esports-betting-rules-FI","94":"source~esports-betting-rules-FR","95":"source~esports-betting-rules-HE","96":"source~esports-betting-rules-IT","97":"source~esports-betting-rules-JA","98":"source~esports-betting-rules-KA","99":"source~esports-betting-rules-LT","100":"source~esports-betting-rules-LV","101":"source~esports-betting-rules-PL","102":"source~esports-betting-rules-PT","103":"source~esports-betting-rules-PT-BR","104":"source~esports-betting-rules-RO","105":"source~esports-betting-rules-RU","106":"source~esports-betting-rules-SQ","107":"source~esports-betting-rules-SR","108":"source~esports-betting-rules-SV","111":"source~generated-mappings","112":"source~i18n-en-json","113":"source~i18n-en-uk-json","114":"source~i18n-es-json","115":"source~i18n-fi-json","117":"source~settings-page","118":"source~streaming-carousel","119":"source~virtual-esports-betting-rules-AZ","120":"source~virtual-esports-betting-rules-EN","121":"source~virtual-esports-betting-rules-HE","122":"source~virtual-esports-betting-rules-IT","123":"source~virtual-esports-betting-rules-JA","124":"source~virtual-esports-betting-rules-PL","125":"source~virtual-esports-betting-rules-RU","127":"vendors~rc-slider","128":"vendors~react-google-recaptcha","129":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"0b377f0e2139cde02779","1":"ea290f29b90a1fda4236","2":"c7f31e26402a5ff6629e","3":"aa3be7f7b85dab291a2c","4":"b85b2c0190c0448f8db0","5":"1bc025e9f339073e1b51","6":"61506cbdc9f9ba2f6381","8":"08618180e2f621eea947","9":"f3e0be08b6fdcb21a198","10":"49fc162b0fd33a28b9bd","11":"153f91c96d046ae99998","15":"9049fdd15eadfe5f4871","16":"564a9cd3339cf4414612","17":"de1b0dfe3bee86112f9e","18":"ab91fea84b12e22e2ea9","19":"84f422916ff376fcddc7","20":"4bb74aecea95fedcae4b","21":"fb64a019cc93fe736d34","22":"93eba773fb022b48a5bf","23":"88ce0c53ee82d4b38c80","24":"6706a7638a5bdc9e47b3","25":"e8f8ca61a60a3a4151fa","26":"a25e5fe764141bfa9384","27":"ba5c56736884413eb633","28":"d25a7ae5834b9a58b231","29":"c9da52e5537c449e9506","30":"39f89834e0a56f56e1c8","31":"e1d5fea7cfba928e7f5f","32":"a3f8b154d4735fa12545","33":"bfcb14895cc71deee296","34":"d0fa0137dd2eaa463628","35":"1ef6ba3f69c1111c35f4","36":"4119bcd7fd8d5de16e97","37":"8e019fbe4a8583620610","38":"44f3260dd987e5db9a7f","39":"45ad2a3d187aa7323c54","40":"bfd07fe58459b175507d","41":"39bac2d2042a7596f31b","42":"e0274b98164848320983","43":"6d1340ab709eec372fac","44":"b0d4b94f6d3202f63996","45":"2d6dafa749f768c3279f","46":"30a9e993c67938827192","47":"0a2e8930147695c9ae69","48":"7dccd7b72e01357daea4","49":"4976afb56889c7a242c4","50":"005e683b90c3f0cf403c","51":"8549e7a2eb48f5f8bab5","52":"ae75086efb7034ce295b","53":"db08c89022df3c9c7d52","54":"6b182a78154790533806","55":"0bebe8c35524afbd5cac","56":"482f5f39c7c07e3ff5c4","57":"bcb971a2af61c9e03f80","58":"02a0450b7f7dbf6d6d3b","59":"2705adb0924791a7932d","60":"98cf6be98711aa951661","61":"bac951ab79705a711296","62":"77a8f5ba00d3b19c9f5b","63":"974b96f5a92e4e943bcb","64":"06bc3352a99e426bb991","65":"93b5c6a331fe2d8653cd","66":"019f236e4e88128b7280","67":"e42898a0e46a942b8f11","68":"0080101361e457a35a49","69":"0da94020a4d96832f086","70":"c8f719475f7bbcd21ac1","71":"3a7f9809a35021155e31","72":"4c89e9ea13ca28518f38","73":"48a78cf71b158798296f","74":"3cb6d51078f984683a8a","75":"ae2b2fc24ef2aceb264a","76":"ec57d3f5f7091f279956","77":"cf8bebcf83f024047be6","78":"1cbe0f09096027c1485a","79":"8dfb8f5ea61d22159a01","80":"59620c750c0d4ffc1b7c","81":"e98d67155bfee29f75e5","82":"40ff686d14dc84b7a8dc","83":"735f1933f9830a11096e","84":"f43581fa77874c0453b6","85":"4f98c892cb5c35d0b125","86":"f5f0ed2dbe3604df8da7","87":"1fb8f58f5b31a37a1759","88":"2f56364fd24fe218f55c","89":"bdb5160cfee5889fc5c4","90":"d090a4a44f8fd5ae30b9","91":"e114078597d21fa3be2c","92":"1f1255e26f8fe079f20b","93":"5501a033656fda78585a","94":"af9f54617cd940500ecd","95":"6243d12929cf150236c3","96":"2957abf6804997508b57","97":"eac37e1217c17b6b60bc","98":"42ea5bd1e5da932cc95a","99":"32175bc8478a7e975dbf","100":"37962a90c760cf06cee9","101":"72aacff791984b8da01d","102":"1713b9116e36dbb4a468","103":"6da1a5d2b536460d03e0","104":"4c7d9eaa4385ad3660ec","105":"b71dd1950d889b3ca3aa","106":"7da6d39dd250cf5d40ed","107":"d370332165c87be686d6","108":"f60b85b1536abf1f7178","111":"15b394955d49138a53c2","112":"9f9309f08802276f4069","113":"dd4854337f7a99e0e61b","114":"f573e9a7860a975dbd4e","115":"171aa52c3b3444a8c6b6","117":"03b70d72bdfd0498f6f5","118":"5be1d8476793c6ab343b","119":"83c09660cfc472dfd169","120":"a4d0a73a22be066fd0f2","121":"7bac1f51dd3084483d2b","122":"755ebdd9ed16ddcda236","123":"52e6ad728a5defe8da51","124":"11e811a31284b26757ae","125":"d576ff07791f24cc40e8","127":"fda1e6500c77d05be45b","128":"2308a17be23aed58640f","129":"59f38f8b78fe8688ec1f","130":"99254767a68b6ec21db7","131":"2d255ba66b8adf78fa9e","132":"cce6138c22ae5d4726b8","133":"4a78392d3c485a280f8b","134":"65935962d04a6a60fb12","135":"5a3481d1f024525e8fa3","136":"acfbeb43f4361eb2352c","137":"6abf9cfd4e242b69ced5","138":"1e45abdb1bdaee8b17fd","139":"21d7e039b8ed52a55814","140":"1d12e4b8a6a6a6df8aa7","141":"afba753b6c271f32999b","142":"12472cf04d57559c44e2","143":"3e16f6a91be04d4579b9","144":"e02fefd3b939b86daf57","145":"c1aefac7adc1e93ba9a7","146":"cd4231dc68b8bfe32c73","147":"f6e675259a62edc8850b","148":"3bdc995f4720c85b0c3d","149":"a8988393716b38c92faf","150":"1b20c7921e35fc7ee8b8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
